import {customElement, property} from "lit/decorators.js";
import {html, LitElement, type TemplateResult} from "lit";
import Styles from "./calendarEntryBadge.lit.scss";
import {LocatedDates} from "../../../common/utils/dates/locatedDates";
import {resolve} from "../../../container";


@customElement("eop-calendar-entry-badge")
export class EopCalendarEntryBadge extends LitElement {

    public static readonly styles = Styles;

    @property()
    public date: Date;

    public constructor(private dates: LocatedDates = resolve(LocatedDates)) {
        super();
    }

    public render(): TemplateResult {
        return html`
            <div class="badge">
                <div class="month">${this.dates.toLocalMonthString(this.date, "short")}</div>
                <div class="day">${this.dates.toLocalDayString(this.date, "numeric")}</div>
                <div class="weekday">${this.dates.toLocalWeekdayString(this.date, "short")}</div>
            </div>
        `;
    }
}